
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/platformPanels/panels/extensions/platformExtensionsPrimaryPanel.scss.css.virtualfile';
        module.exports = {"root":"_root_1244o_1"};